var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BaseActionMenu',{attrs:{"actions":_vm.getProjectActions(),"always-visible":""}}),_c('ProjectSprintDisplayedStatusesMenu',{key:_vm.$route.params.projectId})],1)}
var staticRenderFns = []

export { render, staticRenderFns }